import { call, put, select, take, fork, SagaReturnType } from "redux-saga/effects";
import slice from "../../../containers/App/reducer";
import { makeSelectHost, makeSelectUserInfo } from "../../../containers/App/selectors";
import workCompanyApi from "../../../api/apiServices/auth/controllers/workCompany/workCompany.api";
import { notifyWorkCompanyChange } from "../../../containers/App/workCompanyTabs";
import { getWorkCompanyLandingPath } from "../../../containers/App/workCompanyNavigation";

function* switchWorkCompanyWatcher() {
  while (true) {
    const { payload: companyId }: ReturnType<typeof slice.actions.switchWorkCompany> = yield take(slice.actions.switchWorkCompany.type);
    try {
      if (!Number.isSafeInteger(companyId) || companyId <= 0) throw new Error("Invalid company");
      const host: ReturnType<ReturnType<typeof makeSelectHost>> = yield select(makeSelectHost());
      const user: ReturnType<ReturnType<typeof makeSelectUserInfo>> = yield select(makeSelectUserInfo());
      if (!user?.id || user.company.id === companyId) throw new Error("Invalid company switch");
      const landingPath = getWorkCompanyLandingPath(host, window.location.search);
      const expectedContextVersion = user.contextVersion;
      if (!expectedContextVersion) {
        throw new Error("Work company context version is required");
      }
      const result: SagaReturnType<typeof workCompanyApi.switchCompany> = yield call(workCompanyApi.switchCompany, {
        companyId,
        expectedContextVersion,
      });
      if (
        !result.success ||
        result.success.payload.user?.id !== user.id ||
        result.success.payload.user?.company?.id !== companyId ||
        !result.success.payload.contextVersion?.trim() ||
        result.success.payload.contextVersion === expectedContextVersion
      ) {
        throw new Error("Work company switch was not confirmed");
      }
      yield put(slice.actions.switchWorkCompanySuccess());
      notifyWorkCompanyChange(host, user.id, expectedContextVersion, result.success.payload.contextVersion);
      // Do not install a new version over old forms/stores. Bootstrap a fresh page.
      window.location.replace(landingPath);
    } catch {
      // A lost response may hide a committed switch. Require a reload instead of retrying.
      yield put(slice.actions.switchWorkCompanyReject());
    }
  }
}

export function* workCompanyFlow() {
  yield fork(switchWorkCompanyWatcher);
}
